// @ts-check
/**
 * Typed client for the auth API (login flow only).
 *
 * TYPES ARE GENERATED, NOT HAND-WRITTEN. See `schema.d.ts` header for details.
 *
 *     npm run generate:types-from-openapi-schema
 */
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */

/** @typedef {Schemas['EmailLookupResponse']} EmailLookupResponse */
/** @typedef {Schemas['AllAuthAuthenticationResponse']} AllAuthAuthenticationResponse */

/**
 * POST /api/auth/email-lookup/ — determine login method for an email.
 * @param {string} email
 * @returns {Promise<EmailLookupResponse>}
 */
export async function emailLookup(email) {
  const { data } = await axios.post('/api/auth/email-lookup/', { email })
  return data
}

/**
 * POST /_allauth/browser/v1/auth/login — email/password login.
 * @param {string} email
 * @param {string} password
 * @returns {Promise<AllAuthAuthenticationResponse>}
 */
export async function login(email, password) {
  const { data } = await axios.post('/_allauth/browser/v1/auth/login', {
    email,
    password,
  })
  return data
}

/**
 * GET /_allauth/browser/v1/auth/session — get current session.
 * @returns {Promise<AllAuthAuthenticationResponse>}
 */
export async function fetchSession() {
  const { data } = await axios.get('/_allauth/browser/v1/auth/session')
  return data
}
